import store from '@/store';
import { getNode } from '@/helpers/faqTree/getNode';

async function fetchAppConfigIfEmpty() {
    if (!store.state.appConfig.isAppConfigLoaded) {
        await store.dispatch('appConfig/fetchAppConfig')
    }
}

async function fetchDocumentsIfEmpty() {
    if (!store.state.documents.documentList.length) {
        await store.dispatch('documents/fetchDocumentList')
    }
}

async function fetchFaqDataIfEmpty() {
    if (!store.state.FAQ.isFaqDataLoaded) {
        await store.dispatch('FAQ/fetchFaqData')
    }
}

async function fetchFeedbackQuestionsIfEmpty() {
    if (!store.state.feedback.feedbackQuestionList.isLoaded) {
        await store.dispatch('feedback/fetchFeedbackQuestion')
    }
}

function removePreloader() {
    if (store.getters['message/isStatusWaiting']) {
        store.commit('message/hide');
    }
}

function getTargetFaqPage() {
    return store.state.FAQ.isFaqTreeExist ? getNode('attributes.uuid', store.state.urlParams.page) : false
}

export {
    fetchAppConfigIfEmpty,
    fetchDocumentsIfEmpty,
    fetchFaqDataIfEmpty,
    fetchFeedbackQuestionsIfEmpty,
    removePreloader,
    getTargetFaqPage
}